export default document;
